// extracted by mini-css-extract-plugin
export var divider = "_ml-0";
export var systemMessage = "_ml-1";
export var systemMessageWrapper = "_ml-2";